var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobalDiscovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#D5D6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_1316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.625 28.5242H42.192L39.4085 24.899L36.625 28.5242ZM36.625 32.1493H42.192L39.4085 35.7745L36.625 32.1493Z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8517 19.4613H26.4187V41.2121H20.8517C20.6056 41.2121 20.3696 41.1167 20.1956 40.9467C20.0216 40.7767 19.9238 40.5462 19.9238 40.3059V20.3676C19.9238 20.1272 20.0216 19.8967 20.1956 19.7267C20.3696 19.5568 20.6056 19.4613 20.8517 19.4613Z",
    fill: "#2E3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2744 19.4613H33.8414C34.0875 19.4613 34.3235 19.5568 34.4975 19.7267C34.6715 19.8967 34.7693 20.1272 34.7693 20.3676V40.3059C34.7693 40.5462 34.6715 40.7767 34.4975 40.9467C34.3235 41.1167 34.0875 41.2121 33.8414 41.2121H28.2744V19.4613Z",
    fill: "#2E3192"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_1316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2681,
    height: 21.7508,
    fill: "white",
    transform: "translate(19.9238 19.4613)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalDiscovery);
export default __webpack_public_path__ + "static/media/globalDiscovery.b586da5848ccdb14dc5a28fb50f35953.svg";
export { ForwardRef as ReactComponent };